import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { SelfserviceActivityListUserResponse } from '../../../../../../libs/shared/generated/src/lib/types/selfservice';

type PreEmploymentActivity = SelfserviceActivityListUserResponse['items'][number];

@Component({
  selector: 'app-pre-employment-list-activities',
  imports: [CommonModule, ButtonModule, TranslateModule],
  templateUrl: './pre-employment-list-activities.component.html',
})
export class PreEmploymentListActivitiesComponent {
  constructor(
    private readonly translate: TranslateService,
  ) {

  }
  activities = input.required<PreEmploymentActivity[]>();

  activityClick = output<PreEmploymentActivity>();

  hiredAt = input<string | null>(null);

  getDeadline(activity: PreEmploymentActivity): Date | null {
    const hired = this.hiredAt();
    if (!hired) return null;

    const deadline = new Date(hired);
    deadline.setUTCDate(deadline.getUTCDate() + activity.hiringDateOffsetDeadline);
    return deadline;
  }

  getButtonLabel(activity: PreEmploymentActivity): string {
    if (this.isActivityBlocked(activity)) {
      return this.translate.instant('pre-employment.list-activities.button-label-is-blocked');
    }

    if (activity.isCompleted) {
      return this.translate.instant('pre-employment.list-activities.button-label-is-completed');
    }

    switch (activity.kind) {
      case 'FILE_UPLOAD':
        return this.translate.instant('pre-employment.list-activities.button-label-file-upload');

      case 'SIGN_DOCUMENTS':
        return this.translate.instant('pre-employment.list-activities.button-label-sign-documents');
      case 'SELF_SERVICE':
      case 'ACKNOWLEDGEMENT':
      default:
        return this.translate.instant('pre-employment.list-activities.button-label-acknowledgment-self-service');
    }
  }

  isActivityBlocked(activity: PreEmploymentActivity): boolean {
    return activity.isBlockedByPreviousActivities;
  }

  onActivityClick(activity: PreEmploymentActivity): void {
    if (this.isActivityBlocked(activity)) {
      return;
    }

    this.activityClick.emit(activity);
  }

}